import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Lock, ArrowUpRight, ArrowLeft } from 'lucide-react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { loginAdmin } from '../../api';
import { COMPANY } from '../../mock';

const HERO = 'https://images.unsplash.com/photo-1713593930871-e21d7f9ef4a1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('egea_admin_email');
    if (saved) setEmail(saved);
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const ok = await loginAdmin(email.trim(), password);
    setLoading(false);
    if (ok) {
      if (remember) localStorage.setItem('egea_admin_email', email.trim());
      else localStorage.removeItem('egea_admin_email');
      navigate('/admin');
    } else {
      setError('Email sau parolă incorectă.');
    }
  };

  return (
    <div className="min-h-screen bg-[#0d0e10] text-white flex">
      {/* Left hero */}
      <div className="hidden lg:block relative w-1/2 overflow-hidden">
        <img src={HERO} alt="Schele industriale EGEA" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0d0e10] via-[#0d0e10]/40 to-transparent" />
        <div className="absolute inset-0 grain-overlay opacity-40" />
        <div className="relative h-full flex flex-col justify-between p-10">
          <Link to="/" className="inline-flex items-center gap-2 text-[13px] text-white/80 hover:text-white transition-colors">
            <ArrowLeft size={15} /> Înapoi la site
          </Link>
          <div>
            <div className="font-display font-bold text-white text-[34px] leading-tight max-w-[440px]">
              Schele, turnuri și structuri metalice industriale
            </div>
            <p className="text-[14px] text-white/70 mt-3 max-w-[400px]">
              Panou de administrare {COMPANY.name}. Gestionează produse, proiecte, media și utilizatori.
            </p>
          </div>
        </div>
      </div>

      {/* Right form */}
      <div className="relative w-full lg:w-1/2 flex items-center justify-center px-6 py-12">
        <div className="absolute inset-0 grain-overlay opacity-20 lg:hidden" />
        <div className="relative w-full max-w-[380px]">
          <div className="flex items-center gap-2.5 mb-8">
            <div className="h-10 w-10 rounded-md bg-[#f5a524] flex items-center justify-center">
              <span className="font-display font-bold text-[#131313] text-xl">E</span>
            </div>
            <div>
              <div className="font-display font-bold text-white text-[17px]">
                {COMPANY.name}<span className="text-[#f5a524]">.</span>{COMPANY.brandLine}
              </div>
              <div className="text-[11px] text-[#8b8f97] flex items-center gap-1"><Lock size={11} /> Panou administrare</div>
            </div>
          </div>

          <h1 className="font-display font-bold text-[26px] leading-tight">Autentificare</h1>
          <p className="text-[13px] text-[#8b8f97] mt-1.5 mb-7">Introdu emailul și parola de administrator.</p>

          <form onSubmit={submit}>
            <div className="mb-4">
              <Label className="text-[12px] text-[#9a9ea6]">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nume@egea.ro" data-testid="admin-email-input" className="mt-1.5 bg-[#141518] border-[#26282e] text-white placeholder:text-[#5f636b] focus-visible:ring-[#f5a524]" />
            </div>
            <div className="mb-3">
              <Label className="text-[12px] text-[#9a9ea6]">Parolă</Label>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="admin-password-input" className="mt-1.5 bg-[#141518] border-[#26282e] text-white placeholder:text-[#5f636b] focus-visible:ring-[#f5a524]" />
            </div>
            <label className="flex items-center gap-2 text-[13px] text-[#a7abb2] cursor-pointer select-none">
              <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} data-testid="admin-remember-email" className="accent-[#f5a524] h-3.5 w-3.5" />
              Ține minte emailul
            </label>
            {error && <p className="text-[13px] text-[#ef5350] mt-3" data-testid="admin-login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="admin-login-submit" className="btn-accent rounded-md w-full py-3 text-[15px] flex items-center justify-center gap-2 mt-5 disabled:opacity-60">
              {loading ? 'Se conectează...' : 'Autentificare'} <ArrowUpRight size={17} />
            </button>
          </form>

          <div className="mt-6 text-[12px] text-[#6b6f77] bg-[#141518] border border-[#26282e] rounded-md px-3 py-2.5">
            Acces administrare EGEA Fabrica. Contactează administratorul pentru credențiale.
          </div>
        </div>
      </div>
    </div>
  );
}
